/**
 * Nom du fichier d'un en-tête `Content-Disposition` (`attachment; filename="audit.xlsx"`) :
 * `filename*` encodé (RFC 5987) d'abord, puis `filename`, sinon `fallback`. Seul parseur de cet
 * en-tête, pour le back-office comme pour `@gozoki/api`.
 *
 * Nécessite que l'API expose l'en-tête en CORS (`exposeHeaders`), sinon le navigateur le masque en
 * cross-origin et `fallback` sert.
 */
export const attachmentFileName = (
  disposition: string | null | undefined,
  fallback: string,
): string => {
  if (!disposition) return fallback
  const encoded = /filename\*\s*=\s*utf-8''([^;]+)/i.exec(disposition)?.[1]?.trim()
  if (encoded) {
    try {
      return decodeURIComponent(encoded)
    } catch {
      // Encodage invalide : le nom ASCII de `filename` sert.
    }
  }
  return /filename\s*=\s*"?([^";]+)"?/i.exec(disposition)?.[1]?.trim() || fallback
}
